import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, map, tap } from 'rxjs';

import { ParameterService } from '@services/parameter.service';
import { UiService } from '@services/ui.service';
import { ProviderService } from '@services/provider.service';
import { WorkflowService } from '@services/workflow.service';
import { UniverseService } from '@services/universe.service';

import { Parameter } from '@classes/bizzdev/parameter/parameter';
import { ProviderClient } from '@classes/config/provider-client';

export const clientConfigurationResolver: ResolveFn<{
	parameters: Parameter[];
	providerClients: ProviderClient[];
}> = (
	route,
	state,
	parameterSrv = inject(ParameterService),
	providerSrv = inject(ProviderService),
	workflowSrv = inject(WorkflowService),
	universeSrv = inject(UniverseService),
	uiSrv = inject(UiService)
) => {
	uiSrv.routeLoadingStateChanged.next(true);
	return forkJoin([
		parameterSrv.getForClientConfiguration(),
		providerSrv.getProviderClient(),
		workflowSrv.getIntegrationWorkflows(),
        universeSrv.get(),
        universeSrv.getForClientConfiguration()
	]).pipe(
		tap({
			next: () => uiSrv.routeLoadingStateChanged.next(false),
			error: () => uiSrv.routeLoadingStateChanged.next(false)
		}),
		map(([parameters, providerClients, workflows, clientUniverses, universes]) => {
			return { parameters, providerClients, workflows, clientUniverses, universes };
		})
	);
};
